export default {
  SHOW_DIALOG: '@MYYOLA/DIALOGS/SHOW_DIALOG',
  HIDE_DIALOG: '@MYYOLA/DIALOGS/HIDE_DIALOG',
};
